export const Types = {
    SET_START_DATE: 'analytics/SET_START_DATE',
    SET_END_DATE: 'analytics/SET_END_DATE',
    RESET_DATE_FILTERS: 'analytics/RESET_DATE_FILTERS'

}